import axios from 'axios';
import qs from 'query-string';
import message from '../components/message/message.jsx';
import {hideLoading, showLoading} from "../components/loading/loading";
import ModalManager from "../components/modal/modal-manager";
import LoginRegModal from "../components/login-reg-modal/login-reg-modal";
import {setCourseRecords, setMyProjects,setCourses, setUser} from "../reducers/teach";

const base = axios.create({
    baseURL: window.config.apiBaseURL,
    // baseURL: 'http://localhost:3000/proxy/api',
    timeout: 10 * 1000 // 请求超时时间
});
base.interceptors.request.use(config => {
    if (!config.quiet) {
        showLoading(typeof(config.showLoading) == "string" ? config.showLoading : window.L('teach.loading'));
    }
    config.headers = {};
    config.headers['Content-Type'] = 'application/json';
    config.headers['version'] = window.config.version;
    if(qs.parse(location.search).token) {
        localStorage.setItem('api-token', qs.parse(location.search).token)
        window.config.apiToken = qs.parse(location.search).token
    }
    if (window.config.apiToken != undefined) config.headers['api-token'] = window.config.apiToken;
    config.withCredentials = true;
    return config;
}, error => {
    console.error(error);
    Promise.reject(error)
});

base.interceptors.response.use(response => {
    hideLoading();
    const {data: {code, data, msg}} = response;

    if (code === 0) {
        return data;
    }

    const error = {
        message: msg || response.data.message,
        code
    };
    //TODO window.store.dispatch(showMessageMenu(error));
    return Promise.reject(error);

}, error => {
    hideLoading();
    if (error.response) {
        if (error.response.data.code === 1000) { //返回Code 1000自动弹出登录框
            if(location.search === '?type=share&terminal=phone' || location.search === '?type=share'){
                return
            }
            if (window.__wxjs_environment !== 'miniprogram') {
                setTimeout(()=>{
                    ModalManager.open(LoginRegModal,{
                        closeAfterSubmit: true,
                        onClose: () => {},
                        setUser, setCourseRecords, setMyProjects,setCourses, showLoading
                    }, 'login');
                },1000)
            }
        }else {
            //TODO window.store.dispatch(showMessageMenu(error));
            if (error.response && error.response.data
                && typeof (error.response.data.msg || error.response.data.data) == 'string'
                && (!error.config || !error.config.quiet) //如果config设定了quiet:true，不自动显示后端返回的错误
            ) {
                message.show(error.response.data.msg || error.response.data.data);
            }
        }
        return Promise.reject(error.response.data);
    }else {
        return Promise.reject(error)
    }
});

const get = async (url, query, config) => base.get(`${url}?${qs.stringify(query)}`, config);

const post = async (url, data, config) => base.post(url, data, config);

const getGenerator = (url, defaultConfig) => (query, config) => get(url, query, config || defaultConfig);
const postGenerator = (url, defaultConfig) => (data, config) => post(url, data, config || defaultConfig);

export {
    getGenerator as get,
    postGenerator as post
};
